/* These lines of code are defining constants for action types in a Redux application. */
export const LIST_ALL_FRAME_TYPES_SUCCESS =
  'LIST_ALL_FRAME_TYPES_REQUEST_SUCCESS';
export const LIST_ALL_FRAME_TYPES_REQUEST = 'LIST_ALL_FRAME_TYPES_REQUEST';
export const LIST_ALL_FRAME_TYPES_FAILURE = 'LIST_ALL_FRAME_TYPES_FAILURE';
